<!--  -->
<template>
  <div>
    <div>
      <el-form ref="ruleForm" :model="parameter" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="活动标题" prop="title">
          <el-input v-model="parameter.title" v-model.trim="parameter.title" style="width:300px" @input="parameter.title = parameter.title.replace(reg, '')" />
        </el-form-item>
        <el-form-item label="期限选择">
          <el-select v-model="time_type" placeholder="请选择" style="width:300px">
            <el-option
              v-for="item in timeoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
          <el-input v-model="parameter.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="parameter.appoint_day = parameter.appoint_day.replace(/[^A-z0-9]/, '')" />
        </el-form-item>
        <el-form-item v-if="time_type === 1" label="活动时间" prop="date">
          <el-date-picker
            v-model="parameter.date"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:410px"
            :picker-options="pickerOptions"
            :clearable="false"
            @change="datavalue"
          />
        </el-form-item>
        <el-form-item label="赠送书卷" prop="money">
          <el-input v-model="parameter.money" style="width:300px" type="number" />
          <span>可填范围1~10000</span>
        </el-form-item>
        <el-form-item label="赠送名额" prop="user_limit">
          <el-input v-model="parameter.user_limit" style="width:300px" type="number" />
          <span>空为无限，最高为10000</span>
        </el-form-item>
        <el-form-item label="领取类型" prop="limit_type">
          <el-select v-model="parameter.limit_type" placeholder="请选择" style="width:300px">
            <el-option
              v-for="item in [{value: '整体限领', id: 0}, {value: '每天限领', id: 1}]"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
          <span>注：如名额为100名时，整体限领为该活动共有100名；每天限领每天有100名</span>
        </el-form-item>
        <el-form-item style="width:200px">
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { readingservice } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.date[0] == this.parameter.date[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        title: [
          { required: true, message: '请输入活动标题', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '请输入赠送书卷', trigger: 'blur' }
        ],
        user_limit: [
          { required: true, message: '请输入领赠送名额', trigger: 'blur' }
        ],
        limit_type: [
          { required: true, message: '请选择限领类型', trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ],
        date: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ]
      },

      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      parameter: {
        id: 0,
        // stime: null, // 开始时间
        // etime: null, // 结束时间
        title: null, // 标题
        money: '', // 赠送书卷
        date: [],
        user_limit: null, // 赠送名额
        limit_type: null, // 整体类型
        appoint_day: ''
      },
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2,
      stime: null, // 开始时间
      etime: null // 结束时间
    }
  },
  created() {

  },
  mounted() {

  },

  methods: {
    datavalue(val) {
      // this.parameter.stime = val[0]
      // this.parameter.etime = val[1]
      this.stime = val[0]
      this.etime = val[1]
    },

    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.stime
            par.end_time = this.etime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.parameter.appoint_day)
          }
          try {
            await readingservice({
              platform_id: this.platformid,
              activity_type: 4,
              ...par,
              activity_info: {
                data: {
                  ...this.parameter,
                  date: undefined
                },
                action: 'save'
              }
            })
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('close')
          } catch (err) {
            // this.$message({
            //   message: err,
            //   type: 'warning'
            // })
          }
        } else {
          false
        }
      })
    }

  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
/deep/ .el-form-item__content{
   display: flex;
   flex-direction: column;
}
</style>

